export enum NavTheme {
  blue = 'blue',
  white = 'white',
}
export enum Variant {
  base = 'base',
  simple = 'simple',
}
export enum ResponsiveView {
  none = 'none',
  desktop = 'desktop',
  mobile = 'mobile',
}
